import React from 'react';
import SelectorGrid from "../../../form/SelectorGrid/SelectorGrid";
import {DateTimeFormatter} from "../../../../utils/formatters";

class EventList extends React.Component {

    refresh = () => {
        this.list && this.list.refresh();
    }

    refreshBackground = () => {
        this.list && this.list.refreshBackground();
    }

    render() {
        const filterable = true;
        const sortable = true;
        const {view, componentConfig, filter, selection, isLoading} = this.props;
        const props = {componentConfig, filter, loading: isLoading, pageSize: 5, formId: this.props.formId};
        if (view) {
            props.view = view;
        }
        return (
            <SelectorGrid
                ref={(el) => this.list = el}
                gridid={this.props.gridid !== undefined ? this.props.gridid : "EventList"}
                exports={[
                    {
                        as: "excel",
                        label: "Excel",
                        icon: "far fa-file-excel",
                        addFilters: true
                    }
                ]}
                {...props}
                columns={{
                    "id": {header: 'Kód', width: 1, sortable, filterable},
                    "from": {header: 'Időtartam', width: 2, sortable, filterable, renderer: DateTimeFormatter},
                    "to": {header: 'Időtartam', width: 2, sortable, filterable, renderer: DateTimeFormatter},
                    "locations": {header: 'Hely', width: 3, renderer: (locations) => (locations || []).map((location) => location.name).join(", ")},
                    "program.name": {header: 'Program', width: 3, sortable, filterable},
                }}
                orderBy={{field: componentConfig.idfield, direction: "DESC"}}
                selection={selection}
                onSelectionChange={(selection) => this.props.loadForm(selection.value)}
            />
        );
    }
}

export default EventList;
